import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UrlSharedValueObject} from '../../shared/ValueObjects/UrlSharedValueObject.js'
import {HttpSearchRepository} from '../Repositories/HttpSearchRepository.js'

class GetSearchDataFromUrlSearchUseCase extends UseCase {
  #config
  #repository

  static create({config}) {
    return new GetSearchDataFromUrlSearchUseCase({config, repository: HttpSearchRepository.create({config})})
  }

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  @tracer({metric: 'GetSearchDataFromUrlSearchUseCase#execute'})
  @AsyncInlineError()
  async execute({url}) {
    const urlVO = UrlSharedValueObject.createWithSanitize({config: this.#config, url})

    const [error, response] = await this.#repository.getSearchDataFromUrl({urlVO})

    if (error) return Promise.reject(error)

    return response
  }
}

export const factory = GetSearchDataFromUrlSearchUseCase.create
